<template>
  <v-container class="content-box">
    <div class="mt-10 main-title pc-size"><slot>申請一覧</slot></div>
    <div class="mt-16 main-title pt-5 mobile-size"><slot>申請一覧</slot></div>
    <v-tabs
      v-model="searchCondition.tab"
      class="search-tabs-video tabs-font pt-4"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.tabId"
        @click="tabsChange(tab)"
        :class="tab.tabId == 1 ? 'firsttab' : tab.tabId == 5 ? 'lasttab' : ''"
      >
        {{ tab.title }}{{
          tab.tabId == 1
            ? apply_cnt > 0
              ? "（" + apply_cnt + "）"
              : ""
            : tab.tabId == 2
            ? approve_cnt > 0
              ? "（" + approve_cnt + "）"
              : ""
            : tab.tabId == 3
            ? remand_cnt > 0
              ? "（" + remand_cnt + "）"
              : ""
            : ""
        }}
      </v-tab>
    </v-tabs>
    <v-row class="mt-5">
      <v-spacer></v-spacer>
      <v-col class="justify-end searchpanel pc-size">
        <div class="">
          <field-label-normal>支部名</field-label-normal>
          <v-select
            :items="branches"
            item-text="name"
            item-value="code"
            v-model="searchCondition.branch_code"
            dense
            outlined
            hide-details="auto"
            placeholder="支部を選択"
            @change="changeBranch"
          >
          </v-select>
        </div>
        <div class="">
          <field-label-normal>組合員</field-label-normal>
          <v-select
            :items="companies"
            item-text="company_name"
            item-value="id"
            v-model="searchCondition.company_name"
            dense
            outlined
            hide-details="auto"
            placeholder="組合員を選択"
          >
          </v-select>
        </div>
        <div class="">
          <field-label-normal>キーワード</field-label-normal>
          <div class="d-flex">
            <v-text-field
              v-model="searchCondition.keyword"
              dense
              outlined
              placeholder="検索キーワードを入力"
              clearable
              hide-details="auto"
              v-on:keyup.enter="searchData"
            ></v-text-field>
            <v-btn
              color="primary"
              @click="searchData"
              class="btn-margin"
              height="40"
              width="100"
            >
              検索
            </v-btn>
            <v-btn
              @click="clearData"
              class="btn-margin mx-2 clearbtn"
              height="40"
              width="100"
              color="#46A319"
            >
              クリア
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="mobile-size">
      <v-row class="mt-0">
        <v-col col="12" sm="10">
          <field-label-normal>支部名</field-label-normal>
          <v-select
            :items="branches"
            item-text="name"
            item-value="code"
            v-model="searchCondition.branch_code"
            dense
            outlined
            hide-details="auto"
            placeholder="支部を選択"
            @change="changeBranch"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col col="12" sm="10">
          <field-label-normal>組合員</field-label-normal>
          <v-select
            :items="companies"
            item-text="company_name"
            item-value="id"
            v-model="searchCondition.company_name"
            dense
            outlined
            hide-details="auto"
            placeholder="組合員を選択"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col col="12" sm="10">
          <field-label-normal>キーワード</field-label-normal>
          <v-text-field
            v-model="searchCondition.keyword"
            dense
            outlined
            placeholder="検索キーワードを入力"
            clearable
            hide-details="auto"
            v-on:keyup.enter="searchData"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-btn
        color="primary"
        @click="searchData"
        class="btn-margin mt-4"
        height="40"
        width="100"
      >
        <!-- <svg-icon iconClass="Icon awesome-search" /> -->
        検索
      </v-btn>
      <v-btn
        @click="clearData"
        class="btn-margin mt-4 mx-4 white--text clearbtn"
        height="40"
        width="100"
        color="#46A319"
      >
        クリア
      </v-btn>
    </div>
    <v-row class="pt-4 pc-size">
      <v-col cols="2" sm="1" class="mr-6 v-input-control">
        <v-select
          :items="pages"
          v-model="searchCondition.size"
          dense
          solo
          hide-details
          append-icon="mdi-chevron-down"
          @update:items-per-page="searchData"
          class="select-page-size"
        >
          <template v-slot:selection="{ item }">
            <span class="d-flex justify-center" style="width: 100%">
              {{ item.text }}
            </span>
          </template>
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        v-if="totalElements > 0"
        cols="6"
        sm="3"
        class="d-flex justify-end page-per-control"
      >
        {{ searchCondition.size * (searchCondition.page - 1) + 1 }}～{{
          searchCondition.size * searchCondition.page > totalElements
            ? totalElements
            : searchCondition.size * searchCondition.page
        }}件／全{{ totalElements }}件
      </v-col>
      <v-col v-else cols="6" sm="3" class="d-flex justify-end page-per-control">
        0件／全0件
      </v-col>
    </v-row>
    <div class="mobile-size">
      <v-row class="mt-4">
        <v-col class="v-input-control">
          <v-row class="m-size justify-end">
            <v-col cols="4" sm="12" class="text-right v-input-control">
              <v-select
                :items="pages"
                v-model="searchCondition.size"
                dense
                solo
                hide-details
                append-icon="mdi-chevron-down"
                class="select-page-size"
                @update:items-per-page="searchData"
              >
                <template v-slot:selection="{ item }">
                  <span class="d-flex justify-center" style="width: 100%">
                    {{ item.text }}
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="totalElements > 0"
          cols="12"
          sm="12"
          class="d-flex justify-end page-per-control"
        >
          {{ searchCondition.size * (searchCondition.page - 1) + 1 }}～{{
            searchCondition.size * searchCondition.page > totalElements
              ? totalElements
              : searchCondition.size * searchCondition.page
          }}件／全{{ totalElements }}件
        </v-col>
        <v-col
          v-else
          cols="12"
          sm="12"
          class="d-flex justify-end page-per-control"
        >
          0件／全0件
        </v-col>
      </v-row>
    </div>
    <div class="data-table-min-height">
      <v-data-table
        :headers="computedHeaders"
        :items="certificateInfo"
        :item-class="highlight"
        v-model="selected"
        :page.sync="searchCondition.page"
        :items-per-page="searchCondition.size"
        @update:options="optionChange"
        @update:items-per-page="searchData"
        :server-items-length="totalElements"
        item-key="id"
        show-select
        hide-default-footer
        no-data-text="データがありません"
        class="list-table"
        @page-count="totalPages = $event"
        @click:row="rowClick"
        :sort-by.sync="sortByDefault"
        :sort-desc.sync="sortDescDefault"
        @toggle-select-all="selectAllToggle"
        :header-props="{
          sortByText: '並び順'
        }"
      >
        <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
          <v-simple-checkbox
            :ripple="false"
            :value="isSelected"
            @input="select"
          ></v-simple-checkbox>
        </template>
      </v-data-table>
      <v-row cols="12" sm="6" class="py-6 adjust-btn">
        <v-btn
          height="40"
          width="200"
          color="#46A319"
          class="font-weight-bold white--text btn-text"
          :disabled="totalElements < 1"
          :loading="csvdownloading"
          @click="csvDownload()"
        >
          CSVダウンロード
        </v-btn>
        <v-btn
          v-if="loginUser.user_code != this.usertab.UNION_MEMBER"
          height="40"
          width="200"
          color="#EB6B35"
          class="font-weight-bold white--text btn-text"
          :disabled="selected.length < 1"
          :loading="licensedownloading"
          @click="licenseDownload()"
        >
          ラインセンス発行CSV
        </v-btn>
        <v-btn
          v-if="loginUser.user_code != this.usertab.UNION_MEMBER"
          height="40"
          width="200"
          color="#3FB2BC"
          class="font-weight-bold white--text btn-text"
          :disabled="totalElements < 1"
          :loading="addressdownloading"
          @click="addressDownload()"
        >
          宛名用CSV
        </v-btn>
        <v-spacer class="pc-size" />
        <v-col class="d-flex flex-row-reverse mbpagearea">
          <v-pagination
            v-model="searchCondition.page"
            :length="totalPages"
            circle
            :total-visible="5"
            class="page-btn-user"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <!-- <div class="punks">
      <div class="punks-area">
        <span class="punks-text">申請一覧</span>
        <span class="punks-icon"><svg-icon
            class="arrow-icon"
            iconClass="Icon ionic-ios-arrow-forward"
        /></span>
      </div>
    </div> -->
  </v-container>
</template>
<script>
import FieldLabelNormal from "@/components/FormElements/FieldLabelNormal";
import { PAGES } from "@/utils/pages";
import moment from 'moment';
import { searchCertificate, download, addressCSVDownload, liscenseCSVDownload } from "@/api/certificate";
import { USERTAB } from "@/utils/mst-user";
import { getBranch, getCompany } from "@/api/common";
import { STATUSCODE, CSVMAXLENGTH, DELICODE, APPLICATIONCODE } from "@/utils/mst-cert-dest";

export default {
  name: 'Certificate',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  components: {
    FieldLabelNormal,
  },
  data: () => ({
    prevRoute: null,
    isFirstPage: true,
    title: "申請中",
    tabs: [
      { tabId: 1, title: "申請中" },
      { tabId: 2, title: "承認済" },
      { tabId: 3, title: "差し戻し" },
      { tabId: 4, title: "発行済" },
      { tabId: 5, title: "全て" }
    ],
    pages: PAGES,
    totalElements: 0,
    totalPages: 0,
    sortByDefault: "updated_at",
    sortDescDefault: true,
    headers: [],
    usertab: USERTAB,
    statuscode: STATUSCODE,
    csvmaxlength: CSVMAXLENGTH,
    deli_code: DELICODE,
    application_codes: APPLICATIONCODE,
    defaultHeaders: [
      { text: "氏名", value: "cert_name", width: "180px", align: "left" },
      { text: "氏名カナ", value: "cert_kana_name", width: "180px", align: "left" },
      { text: "資格種別", value: "mcert_name", width: "220px", align: "left" },
      {
        text: "資格登録日",
        value: "cert_regist_date",
        width: "175px",
        align: "left",
      },
      {
        text: "資格更新日",
        value: "cert_update_date",
        width: "150px",
        align: "left",
      },
      {
        text: "有効期間",
        value: "cert_expiry_date",
        width: "150px",
        align: "left",
      },
      {
        text: "ﾗｲｾﾝｽ出力日",
        value: "licence_csv_export_date",
        width: "150px",
        align: "left",
      },
    ],
    searchCondition: {
      isIni: true,
      size: 5,
      page: 1,
      tab: 0,
      tabId: 1,
    },
    isSearching: false,
    csvdownloading: false,
    licensedownloading: false,
    addressdownloading: false,
    apply_cnt: '',
    approve_cnt: '',
    remand_cnt: '',
    selected: [],
    certificateInfo: [],
    branches: [],
    companies: [],
    ids: [],
    loginUser: "",
  }),
  computed: {
    computedHeaders() {
      return this.headers;
    },
  },
  created: async function () {
    await this.refresh();
  },
  methods: {
    refresh() {
      this.setHeader();
      this.getLoginUser();
      if (this.$route.query.tabId != undefined) {
        this.searchCondition.tabId = this.$route.query.tabId;
        this.searchCondition.tab = this.$route.query.tabId - 1;
      }
      getBranch().then((response) => {
        this.branches = response.data;
      });

      getCompany().then((response) => {
        this.companies = response.data;
      });
    },
    setHeader() {
      let tempheaders = [];
      this.headers = [];
      const loginUser = JSON.parse(localStorage.getItem("userInfo"));
      if (loginUser) {
        let addcolumn5 = [
          {
            text: "処理区分",
            value: "appli_name",
            width: "150px",
            align: "center",
          },
          {
            text: "ステータス",
            value: "status",
            width: "150px",
            align: "center",
          },
        ];
        let addcolumnnot4 = [
          {
            text: "処理区分",
            value: "appli_name",
            width: "150px",
            align: "center",
          },
        ];
        let admincolumn = [
          { text: "廃止", value: "updated_at", width: "150px", align: "center" },
        ];
        let notunioncolumn = [
          { text: "支部名", value: "branch_name", width: "150px", align: "left" },
          {
            text: "施工店名",
            value: "company_name",
            width: "180px",
            align: "left",
          },
        ];
        if (loginUser.user_code != this.usertab.UNION_MEMBER) {
          tempheaders = notunioncolumn.concat(this.defaultHeaders);
        } else {
          tempheaders = this.defaultHeaders;
        }

        if (this.searchCondition.tabId == this.statuscode.ALL) {
          tempheaders = tempheaders.concat(addcolumn5);
        } else if (this.searchCondition.tabId != this.statuscode.ISSUED) {
          tempheaders = tempheaders.concat(addcolumnnot4);
        }

        if (loginUser.user_code == this.usertab.ADMIN) {
          tempheaders = tempheaders.concat(admincolumn);
        }
        this.headers = tempheaders;
      }
    },
    tabsChange(data) {
      this.searchCondition.tabId = data.tabId;
      this.searchData();
      this.setHeader();
      return this.title = data.title;
    },
    getLoginUser() {
      return this.loginUser = JSON.parse(localStorage.getItem('userInfo'));
    },
    rowClick(data) {
      localStorage.setItem("certSearchCondition", JSON.stringify(this.searchCondition));
      this.$router.push("/user/certificate/edit/" + data.id); // 管理者のログイン画面に遷移
    },
    searchData() {
      if (this.isFirstPage) {
        this.searchCondition.page = 1;
      }
      this.search();
    },
    optionChange(option) {
      // ソート変更があった時に
      this.searchCondition.sort = option.sortBy[0];
      this.searchCondition.sortDesc = option.sortDesc[0];
      this.searchCondition.page = option.page;
      this.search();
    },
    waitforCurrentSearchAndSearch() {
      if (this.isSearching) {
        setTimeout(() => this.waitforCurrentSearchAndSearch(), 100);
      } else {
        this.search();
      }
    },
    async search() {
      this.$store.commit("SET_LOADING", true);

      let loginUser = JSON.parse(localStorage.getItem('userInfo'));
      // 検索リクエスト
      this.isSearching = true;
      const search = {
        size: this.searchCondition.size,
        tabId: this.searchCondition.tabId,
        keyword: this.searchCondition.keyword,
        branchCode: this.searchCondition.branch_code,
        companyName: this.searchCondition.company_name,
        loginid: loginUser.id,
        loginBranch: loginUser.branch_code,
        loginUsercode: loginUser.user_code,
      };
      // 並び順
      if (this.searchCondition.sort != null) {
        search["sort"] = this.searchCondition.sort;
      }

      if (this.searchCondition.sortDesc != null) {
        search["sortDesc"] = this.searchCondition.sortDesc;
      }
      search["page"] = this.searchCondition.page;
      await searchCertificate(search)
        .then((response) => {
          const dataList = [];
          this.apply_cnt = response.apply_cnt;
          this.approve_cnt = response.approve_cnt;
          this.remand_cnt = response.remand_cnt;
          response.data.data.forEach((data) => {
            dataList.push({
              id: data.id,
              branch_name: data.branch_name,
              company_name: data.company_name,
              cert_name: data.cert_name,
              cert_kana_name: data.cert_kana_name,
              mcert_name: data.mcert_name,
              cert_regist_date: data.cert_regist_date
                ? moment(data.cert_regist_date).format("YYYY/MM/DD")
                : "",
              cert_update_date: data.cert_update_date
                ? moment(data.cert_update_date).format("YYYY/MM/DD")
                : "",
              cert_expiry_date: data.cert_expiry_date
                ? moment(data.cert_expiry_date).format("YYYY/MM/DD")
                : "",
              licence_csv_export_date: data.licence_csv_export_date
                ? moment(data.licence_csv_export_date).format("YYYY/MM/DD H:mm")
                : "",
              appli_name: data.appli_name == '処理なし' ? '-' : data.appli_name,
              status: data.status,
              updated_at: data.application_code == this.application_codes.CANCELAPP && data.status_code == this.statuscode.APPROVED ? data.updated_at
                ? moment(data.updated_at).format("YYYY/MM/DD")
                : "" : "-",
              cancel_status: data.application_code == this.application_codes.CANCELAPP && data.status_code == this.statuscode.APPROVED ? true : false,
            });
          });
          this.certificateInfo = dataList;
          this.totalElements = response.data.total;
          this.totalPages = response.data.last_page;
        }).catch(() => {
          this.$router.push("/login");
        });
      this.isSearching = false;
      this.isFirstPage = true;
      this.$store.commit("SET_LOADING", false);
    },
    selectAllToggle(props) {
      if (this.selected.length != this.certificateInfo.length) {
        this.selected = [];
        const self = this;
        props.items.forEach(item => {
          self.selected.push(item);
        });
      } else this.selected = [];
    },
    async csvDownload() {
      let cert_ids = [];
      for (const certificate of this.selected) {
        cert_ids.push(certificate.id);
      }
      let loginUser = JSON.parse(localStorage.getItem('userInfo'));
      const search_data = {
        ids: cert_ids,
        tabId: this.searchCondition.tabId,
        keyword: this.searchCondition.keyword,
        branchCode: this.searchCondition.branch_code,
        companyName: this.searchCondition.company_name,
        loginid: loginUser.id,
        loginBranch: loginUser.branch_code,
        loginUsercode: loginUser.user_code,
      };

      // 並び順
      if (this.searchCondition.sort != null) {
        search_data["sort"] = this.searchCondition.sort;
      }

      if (this.searchCondition.sortDesc != null) {
        search_data["sortDesc"] = this.searchCondition.sortDesc;
      }
      search_data["page"] = this.searchCondition.page;
      await download(search_data)
        .then((response) => {
          if (response.success == false) {
            this.$store.commit("SAVE_DIALOG", {
              text: "一度にエクスポートできるデータ件数は" + this.csvmaxlength + "件までとなります。検索条件を絞るか、チェックボックスで出力対象のレコードを指定してください。",
              icon: "mdi-alert",
              closeEvent: () => { this.closeEv },
            });
          } else {
            var filename = "shinsei_" + moment(Date.now()).format("YYYYMMDDHHmmss") + ".csv";
            const url = window.URL.createObjectURL(
              new Blob([response.data])
            );
            // Create dynamic <a> element
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);

            // Dynamicall click the a link element
            // This will download the csv file
            link.click();
          }
        })
        .catch(() => {
          this.$router.push("/login");
        });
      this.csvdownloading = false;
    },
    async licenseDownload() {
      let cert_ids = [];
      for (const certificate of this.selected) {
        cert_ids.push(certificate.id);
      }
      let loginUser = JSON.parse(localStorage.getItem('userInfo'));
      const search_data = {
        ids: cert_ids,
        tabId: this.searchCondition.tabId,
        keyword: this.searchCondition.keyword,
        branchCode: this.searchCondition.branch_code,
        companyName: this.searchCondition.company_name,
        loginid: loginUser.id,
      };

      // 並び順
      if (this.searchCondition.sort != null) {
        search_data["sort"] = this.searchCondition.sort;
      }

      if (this.searchCondition.sortDesc != null) {
        search_data["sortDesc"] = this.searchCondition.sortDesc;
      }
      search_data["page"] = this.searchCondition.page;
      await liscenseCSVDownload(search_data)
        .then((response) => {
          if (response.success == false) {
            this.$store.commit("SAVE_DIALOG", {
              text: "一度にエクスポートできるデータ件数は" + this.csvmaxlength + "件までとなります。検索条件を絞るか、チェックボックスで出力対象のレコードを指定してください。",
              icon: "mdi-alert",
              closeEvent: () => { this.closeEv },
            });
          } else {
            var filename = "license_" + moment(Date.now()).format("YYYYMMDDHHmmss") + ".zip";
            const url = window.URL.createObjectURL(
              new Blob([response.data])
            );
            // Create dynamic <a> element
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);

            // Dynamicall click the a link element
            // This will download the csv file
            link.click();
          }
        }).catch(() => {
          this.$router.push("/login");
        });
      this.licensedownloading = false;
      this.search();
    },
    async addressDownload() {
      let cert_ids = [];
      for (const certificate of this.selected) {
        cert_ids.push(certificate.id);
      }

      let loginUser = JSON.parse(localStorage.getItem('userInfo'));
      const search_data = {
        ids: cert_ids,
        tabId: this.searchCondition.tabId,
        keyword: this.searchCondition.keyword,
        branchCode: this.searchCondition.branch_code,
        companyName: this.searchCondition.company_name,
        loginid: loginUser.id,
        loginBranch: loginUser.branch_code,
        loginUsercode: loginUser.user_code,
      };
      // 並び順
      if (this.searchCondition.sort != null) {
        search_data["sort"] = this.searchCondition.sort;
      }

      if (this.searchCondition.sortDesc != null) {
        search_data["sortDesc"] = this.searchCondition.sortDesc;
      }
      search_data["page"] = this.searchCondition.page;
      await addressCSVDownload(search_data)
        .then((response) => {
          if (response.success == false) {
            this.$store.commit("SAVE_DIALOG", {
              text: "一度にエクスポートできるデータ件数は" + this.csvmaxlength + "件までとなります。検索条件を絞るか、チェックボックスで出力対象のレコードを指定してください。",
              icon: "mdi-alert",
              closeEvent: () => { this.closeEv },
            });
          } else {
            var filename = "atena_" + moment(Date.now()).format("YYYYMMDDHHmmss") + ".csv";
            const url = window.URL.createObjectURL(
              new Blob([response.data])
            );
            // Create dynamic <a> element
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            // Dynamicall click the a link element
            // This will download the csv file
            link.click();
          }
        })
        .catch(() => {
          this.$router.push("/login");
        });
      this.addressdownloading = false;
    },
    highlight(row) {
      if (row.cancel_status) {
        return 'highlight';
      } else {
        return '';
      }
    },
    changeBranch() {
      let params = {
        branch_code: this.searchCondition.branch_code,
        searchflg: true,
      }
      getCompany(params).then((response) => {
        this.companies = response.data;
      });
    },
    clearData() {
      this.searchCondition.branch_code = '';
      this.searchCondition.company_name = '';
      this.searchCondition.keyword ='';
      getBranch().then((response) => {
        this.branches = response.data;
      });

      getCompany().then((response) => {
        this.companies = response.data;
      });
      this.searchData();
    }
  },
  mounted() {
    if (this.prevRoute.name === "EditCertificate") {
      const savedSearchCondition = JSON.parse(
        localStorage.getItem("certSearchCondition")
      );
      if (savedSearchCondition) {
        this.isFirstPage = false;
        this.searchCondition = savedSearchCondition;
        this.sortByDefault = this.searchCondition.sort;
        this.sortDescDefault = this.searchCondition.sortDesc;
        this.waitforCurrentSearchAndSearch();
      }
      this.setHeader();
    }
    if (this.$route.query.tabId != undefined) {
      this.searchCondition.page = 1;
      this.searchCondition.tabId = this.$route.query.tabId;
      this.searchCondition.tab = this.$route.query.tabId - 1;
    }
    localStorage.removeItem("certSearchCondition");
    const navigationBar = this.$parent.$parent.$parent;
    navigationBar.setFooter(['申請一覧'], '', false);
  },
};
</script>
<style lang="scss" scoped>
.userinfo {
  .pageCount {
    font-size: $size-tip;
    color: $color-text;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab {
    border-left: 2px solid transparent;
    border-right: 2px solid beige;
    width: 148px !important;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:nth-child(2) {
    border-top: 4px solid $sandy-brown;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:nth-child(3) {
    border-top: 4px solid $blue;
  }

  .v-window {
    overflow: visible;
  }
  .chip-text {
    color: $white !important;
    width: 125px !important;
    justify-content: center;
  }
  .item-label {
    color: $dark-blue;
    font-size: $size-label;
  }
}
.row {
  margin-bottom: 0 !important;
}
.main-title {
  font-size: $size-title;
  color: $user-header-title;
  font-weight: bold;
}
.adjust-btn {
  justify-content: start;
}
.btn-text {
  font-size: $size-btn-font;
  margin-right: 20px;
  margin-top: 12px;
}
.v-tab--active {
  border-top: 4px solid $user-checkbox-active-color !important;
}
.btn-area {
  text-align: left;
}
.btn-right {
  margin-right: 20px;
}
.searchicon {
  .svg-icon {
    width: 20.72px;
    height: 20.72px;
  }
}
.searchpanel {
  display: flex;
  .fieldset {
    margin: 5px 6px -1px 0px !important;
  }
  .v-input {
    margin: 1px 8px 0px 0;
    min-width: 200px;
  }
  .v-btn {
    height: 40px;
    color: $white;
    width: 70px;
    background-color: $skyblue !important;
  }
  .clearbtn {
    background-color: $green !important;
  }
}
/**申請一覧のパンくずの */
@media screen and (max-width: 1000px) {
  .data-table-min-height {
    min-height: 50vh;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1400px) {
  .data-table-min-height {
    min-height: 50vh;
  }
  .adjust-btn {
    display: flex;
  }
}
@media screen and (max-width: $size-pc-min) {
  .adjust-btn {
    display: flex;
  }
}
@media screen and (max-width: $size-mobile) {
  .btn-area {
    text-align: center !important;
    justify-content: center !important;
  }
  .btn-text {
    margin-top: 47px !important;
    margin-right: 12px;
    margin-left: 12px;
  }
  .adjust-btn {
    display: block;
    text-align: center !important;
  }
  .mbpagearea {
    padding-top: 32px;
  }
  // .punks-area {
  //   margin-bottom: -40px !important;
  // }
}
</style>
<style lang="scss">
.userinfo {
  .pc-size,
  .mobile-size {
    .v-input {
      .v-label {
        font-size: $size-normal !important;
        color: $color-text !important;
      }
    }
  }
  .search-tabs-video .v-slide-group__content .v-tab.v-tab--active {
    font-weight: 900 !important;
    border-top: 4px solid $user-header-title !important;
  }
  @media screen and (max-width: $size-mobile) {
    .v-data-table__mobile-row__header {
      color: $dark-blue !important;
    }
  }
  .v-badge__wrapper {
    left: 104px !important;
    top: -5px !important;
  }
}
.admin-user-list-dialog {
  margin: 10px !important;
  .round-card {
    .v-card__text {
      padding: 0 13px !important;
    }
  }
  .theme--light.v-label {
    font-size: $size-normal !important;
    color: $color-text !important;
  }
  .v-input--selection-controls {
    margin-top: 0 !important;
  }
}
.highlight {
  background-color: #d5d5d5 !important;
}
tbody {
  tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: RGBA(226, 247, 250, 0.7) !important;
  }
  tr.v-data-table__selected:not(.highlight) {
    //background: RGBA(226, 247, 250, 1) !important;
    background: RGBA(255, 255, 255, 1) !important;
  }
}
.v-data-table-header th {
  border-bottom: 1px solid $user-primary !important;
}
.v-data-table {    
    overflow-x: scroll;
}
</style>
